var ko = require('knockout');

ko.components.register('loader', {
  viewModel: require('./loader'),
  template: require('./loader.template')
});

$('[data-loader]').each(function() {
  ko.applyBindings({}, this);
});
